import { render, staticRenderFns } from "./ParticipantPermissionsEditor.vue?vue&type=template&id=21cd1140"
import script from "./ParticipantPermissionsEditor.vue?vue&type=script&lang=js"
export * from "./ParticipantPermissionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports